import React from "react";

export default function Experience() {
  return (
    <div
      id="experience"
      className="items-center px-6 py-8 text-white bg-mesanfaz-black sm:px-8 md:px-12 md:py-12"
    >
      <div className="text-4xl font-black sm:text-5xl md:text-6xl lg:text-4xl xl:text-5xl 2xl:text-6xl">
        experience
      </div>
      <div className="pt-12">
        <ol className="relative border-l border-gray-200">
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Backend Developer - Fulltime
            </h3>
            <time className="block mb-2 leading-none">
              PT Global Prima Textilindo
            </time>
            <time className="block mb-2 leading-none">
              West Jakarta - Indonesia
            </time>
            <time className="block mb-2 leading-none">Jun 2024 - Sep 2024</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Developed an API for the internal company platform Asana
                  System that is specifically designed to optimize employee task
                  or activity management and is designed as a tool to support
                  effective task management and monitoring, which can increase
                  productivity and collaboration in the work environment.
                </li>
                <li>
                  Assigned to developed an API for the internal web platform
                  Chat Panel System specifically designed by the company to
                  provide an enhanced communication flow between the Customer
                  Support team and customers through integration with the
                  WhatsApp platform.
                </li>
                <li>
                  Developed an API for the internal panel system Cititex Master
                  Panel System designed to enhance management efficiency of
                  company data and provide controlled access to authorized
                  users.
                </li>
                <li>
                  Assigned to developed an API for Webhook System web based
                  platform specifically designed for internal company use that
                  provides a communication bridge to connect multiple other
                  internal websites automatically.
                </li>
                <li>
                  Integrated media effectively with AWS S3 cloud based storage
                  services and carried out efficient data transfer management
                  using Putty and Filezilla applications to ensure optimal data
                  flow.
                </li>
              </ul>
            </div>
          </li>
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Backend Developer - Internship
            </h3>
            <time className="block mb-2 leading-none">
              Core Initiative Studio x Rakamin Academy
            </time>
            <time className="block mb-2 leading-none">Online - Indonesia</time>
            <time className="block mb-2 leading-none">May 2023 - Jun 2023</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Completed a simple Todo API project created using Echo
                  framework which functions for todo management and user
                  management.
                </li>
                <li>
                  Accomplished a simple Self Payroll API project that functions
                  for self payroll with other additional features such as data
                  management for employees, companies, and transactions.
                </li>
                <li>
                  Achieved beginner proficiency and expertise with 99% lesson
                  completion progress utilizing Echo framework for backend
                  development.
                </li>
                <li>
                  Enhanced competency and proficiency with 99% lesson completion
                  rate utilizing Gin framework effectively for developing
                  applications.
                </li>
                <li>
                  Improved comprehension and proficiency with 99% course
                  completion progress utilizing Go programming language leading
                  to advanced usage for efficient and effective backend
                  development practices.
                </li>
              </ul>
            </div>
          </li>
          <li className="mb-8 ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Backend Developer - Fulltime
            </h3>
            <time className="block mb-2 leading-none">
              PT Permata Indo Sejahtera
            </time>
            <time className="block mb-2 leading-none">
              South Jakarta - Indonesia
            </time>
            <time className="block mb-2 leading-none">Apr 2022 - Feb 2023</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Designed and developed API for Kerja365 Business outsourcing
                  website. Kerja365 Business is an outsourcing website that
                  facilitates employee booking and employee management for
                  internal corporate customers.
                </li>
                <li>
                  Designed and implemented an API for non-administrative
                  versions of MyWorkSpace mobile application. This application
                  is designed as an internal tool for employees to manage
                  attendance, manage loans, manage personal data and other
                  functions.
                </li>
                <li>
                  Assigned with responsibilities to interview for potential
                  Backend Developer candidates in the recruitment process.
                </li>
                <li>
                  Assigned to guide and enhance new employee growth and
                  professional development in the team ecosystem.
                </li>
                <li>
                  Consistently achieving sprint targets accelerated project
                  timelines and optimized operational efficiencies ahead of
                  schedule.
                </li>
              </ul>
            </div>
          </li>
          <li className="ml-6">
            <span className="absolute flex items-center justify-center w-4 h-4 lg:w-5 lg:h-5 bg-mesanfaz-gray rounded-full -left-2 lg:-left-2.5"></span>
            <h3 className="flex items-center mb-1 text-lg font-black sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl">
              Backend Developer - Internship
            </h3>
            <time className="block mb-2 leading-none">
              Yayasan Qodr Tarbiyatul Islam
            </time>
            <time className="block mb-2 leading-none">
              Yogyakarta - Indonesia
            </time>
            <time className="block mb-2 leading-none">Sep 2019 - Jan 2020</time>
            <div className="mb-4">
              <ul className="ml-5 text-justify list-disc">
                <li>
                  Enhanced proficiency in website development utilizing Laravel
                  6 framework and achieved strong mastery for basic technical
                  functions with 90% completion course.
                </li>
                <li>
                  Improved comprehension and basic mastery with 90% completion
                  rate in complicated Application Programming Interface (API)
                  fields with demonstrated proficiency in utilization and
                  implementation.
                </li>
                <li>
                  Enhanced skills and insights achieved as Backend Developer and
                  completed up to 50% lessons to navigate backend architecture
                  and protocols.
                </li>
                <li>
                  Accomplished simple projects with existing proficiency
                  utilizing Laravel framework to achieve great results.
                </li>
                <li>
                  Engaged as Customer Service at woo-wa.com and contributed
                  necessary services to customers.
                </li>
              </ul>
            </div>
          </li>
        </ol>
      </div>
    </div>
  );
}
